export const versionQaIds = (qaPrefix: string) => ({
  undo: `${qaPrefix}-undo`,
  redo: `${qaPrefix}-redo`,
  restoring: `${qaPrefix}-restoring`,
  reconnecting: `${qaPrefix}-reconnecting`,
  version: `${qaPrefix}-version`,
  restoreEvent: `${qaPrefix}-restore-event`,
});
